import { AxiosError, AxiosResponse } from 'axios';
import { ProgramaCheckedAno } from 'models/escola';
import {
  CadastroEscola,
  CadastroEscolaRequest,
} from 'pages/Escola/Cadastro/etapas/Informacoes/__types';
import {
  LoadedCoopEscola,
  LoadedTipoDocumento,
} from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/listaPrograma/listaPeriodo/listaPeriodoItem/cooperativa/Modal/ModalAddCoop/DocumentCoop/__types';
import {
  EscolaEditTabs,
} from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__enum';
import { Dispatch } from 'redux';
import { getApis } from '../../library/Apis';
import {
  ESCOLA_STATUS_ATIVADA,
  ESCOLA_STATUS_DESATIVADA,
} from '../../library/EscolaStatus';
import { toRequest } from '../../utils/RequestUtils';
import { NUMERO_NAO_INFORMADO } from '../../utils/ValidationUtils';
import { AssessorData, LoadedAssessorDataAction, TipoPrograma } from './EscolasTypes';
import { ProgramasResponse } from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__types';
// Action Types
export const LOADED_DADOS_DA_ESCOLA_ACTION = 'LOADED_DADOS_DA_ESCOLA_ACTION';
export const LOADED_DADOS_DA_ESCOLA_COOP_ACTION = 'LOADED_DADOS_DA_ESCOLA_COOP_ACTION';
export const LOADED_DADOS_DA_ESCOLA_FINANCAS_ACTION = 'LOADED_DADOS_DA_ESCOLA_FINANCAS_ACTION';

export const LOADED_PERIODO_ACTION = 'LOADED_PERIODO_ACTION';
export const LOADED_PERIODO_COOP_ACTION = 'LOADED_PERIODO_COOP_ACTION';
export const LOADED_PERIODO_FINANCAS_ACTION = 'LOADED_PERIODO_FINANCAS_ACTION';

export const LOADED_PERIODOS_ACTION = 'LOADED_PERIODOS_ACTION';
export const LOADED_PERIODOS_COOP_ACTION = 'LOADED_PERIODOS_COOP_ACTION';
export const LOADED_PERIODOS_FINANCAS_ACTION = 'LOADED_PERIODOS_FINANCAS_ACTION';

export const SAVED_PERIODO_ACTION = 'SAVED_PERIODO_ACTION';
export const SAVED_PERIODO_COOP_ACTION = 'SAVED_PERIODO_COOP_ACTION';
export const SAVED_PERIODO_FINANCAS_ACTION = 'SAVED_PERIODO_FINANCAS_ACTION';

export const REMOVED_PERIODO_ACTION = 'REMOVED_PERIODO_ACTION';
export const REMOVED_PERIODO_FINANCAS_ACTION = 'REMOVED_PERIODO_FINANCAS_ACTION';

export const CHANGED_PERIODO_EDITING_VALUE_ACTION = 'CHANGED_PERIODO_EDITING_VALUE_ACTION';
export const CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION = 'CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION';
export const CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION = 'CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION';

export const LOADING_ALL_PERIODOS_ACTION = 'LOADING_ALL_PERIODOS_ACTION';
export const LOADED_ALL_PERIODOS_ACTION = 'LOADED_ALL_PERIODOS_ACTION';
export const LOADING_PERIODOS_ACTION = 'LOADING_PERIODOS_ACTION';
export const LOADING_PERIODOS_COOP_ACTION = 'LOADING_PERIODOS_COOP_ACTION';
export const LOADING_PERIODOS_FINANCAS_ACTION =
  'LOADING_PERIODOS_FINANCAS_ACTION';

export const LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID =
  'LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID';
export const LOADING_ALL_ESCOLAS_BY_LIST_CIDADE_ID =
  'LOADING_ALL_ESCOLAS_BY_LIST_CIDADE_ID';
export const LOADED_IDEB_ACTION = 'LOADED_IDEB_ACTION';
export const LOADING_ALL_IDEBS_ACTION = 'LOADING_ALL_IDEBS_ACTION';
export const LOADED_ALL_IDEBS_ACTION = 'LOADED_ALL_IDEBS_ACTION';
export const LOADING_IDEB_ACTION = 'LOADING_IDEB_ACTION';
export const CHANGED_IDEB_EDITING_VALUE_ACTION =
  'CHANGED_IDEB_EDITING_VALUE_ACTION';
export const SAVED_IDEB_ACTION = 'SAVED_IDEB_ACTION';
export const CREATED_IDEB_ACTION = 'CREATED_IDEB_ACTION';
export const REMOVED_IDEB_ACTION = 'REMOVED_IDEB_ACTION';
export const RESETED_ESCOLAS = 'RESETED_ESCOLAS';
export const LOADED_ESCOLA_ACTION = 'LOADED_ESCOLA_ACTION';
export const CHANGE_ESCOLA_STATUS_ACTION = 'CHANGE_ESCOLA_STATUS_ACTION';
export const CREATED_ESCOLA_ACTION = 'CREATED_ESCOLA_ACTION';
export const SAVED_ESCOLA_ACTION = 'SAVED_ESCOLA_ACTION';
export const CHANGED_ESCOLA_EDITING_VALUE_ACTION =
  'CHANGED_ESCOLA_EDITING_VALUE_ACTION';
export const CLEARED_PERIODO_ACTION = 'CLEARED_PERIODO_ACTION';
export const CLEARED_PERIODO_COOP_ACTION = 'CLEARED_PERIODO_COOP_ACTION';
export const CLEARED_PERIODO_FINANCAS_ACTION = 'CLEARED_PERIODO_FINANCAS_ACTION';
export const CLEARED_ESCOLA_ACTION = 'CLEARED_ESCOLA_ACTION';
export const CLEARED_IDEB_ACTION = 'CLEARED_IDEB_ACTION';
export const CLEARED_ESCOLAS_PAGE_ACTION = 'CLEARED_ESCOLAS_PAGE_ACTION';
export const CLEARED_ALL_IDEB_ACTION = 'CLEARED_ALL_IDEB_ACTION';
export const LOADED_ESCOLAS_PAGE_ACTION = 'LOADED_ESCOLAS_PAGE_ACTION';
export const LOADING_ESCOLAS_BY_COOPS_ACTION =
  'LOADING_ESCOLAS_BY_COOPS_ACTION';
export const LOADED_ESCOLAS_BY_COOPS_ACTION = 'LOADED_ESCOLAS_BY_COOPS_ACTION';
export const LOADING_ESCOLAS_ACTION = 'LOADING_ESCOLAS_ACTION';
export const LOADED_ESCOLAS_ACTION = 'LOADED_ESCOLAS_ACTION';
export const LOADING_ESCOLAS_POR_CIDADE_ACTION =
  'LOADING_ESCOLAS_POR_CIDADE_ACTION';
export const LOADED_ESCOLAS_POR_CIDADE_ACTION =
  'LOADED_ESCOLAS_POR_CIDADE_ACTION';
export const LOADING_ESCOLAS_POR_ESTADO_CIDADE_ACTION =
  'LOADING_ESCOLAS_POR_ESTADO_CIDADE_ACTION';
export const LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION =
  'LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION';
export const LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION =
  'LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION';
export const LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION =
  'LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION';
export const SET_CURRENT_TAB_PROGRAMA = 'SET_CURRENT_TAB_PROGRAMA';
export const LOADING_ETAPAS_ENSINO_ACTION = 'LOADING_ETAPAS_ENSINO_ACTION';
export const LOADED_ETAPAS_ENSINO_ACTION = 'LOADED_ETAPAS_ENSINO_ACTION';
export const LOADING_PRINCIPIO_VALOR_ACTION = 'LOADING_PRINCIPIO_VALOR_ACTION';
export const LOADED_PRINCIPIO_VALOR_ACTION = 'LOADED_PRINCIPIO_VALOR_ACTION';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const HANDLE_NEXT = 'HANDLE_NEXT';
export const HANDLE_BACK = 'HANDLE_BACK';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const CLEAR_FORM_DATA = 'CLEAR_FORM_DATA';
export const RESET_FORM_DATA = 'RESET_FORM_DATA';
export const PROCESS_API_DATA = 'PROCESS_API_DATA';
export const UPDATE_SELECTED_CHECKBOXES = 'UPDATE_SELECTED_CHECKBOXES';
export const UPDATE_FORM_DATA_ADD_COOP = 'UPDATE_FORM_DATA_ADD_COOP';
export const LOADING_MODALIDADES_ACTION = 'LOADING_MODALIDADES_ACTION';
export const LOADED_PROGRAMA_INFO_ACTION = 'LOADED_PROGRAMA_INFO_ACTION';
export const LOADED_MODALIDADES_ACTION = 'LOADED_MODALIDADES_ACTION';
export const LOADING_PROGRAMAS_ACTION = 'LOADING_PROGRAMAS_ACTION';
export const LOADED_PROGRAMAS_ACTION = 'LOADED_PROGRAMAS_ACTION';
export const UPDATE_PROGRAMA_VALUE = 'UPDATE_PROGRAMA_VALUE';
export const RESET_PROGRAMA_VALUE = 'RESET_PROGRAMA_VALUE';
export const SAVED_PROGRAMAS_ACTION = 'SAVED_PROGRAMAS_ACTION';
export const SUBMIT_COOP_DATA_SUCCESS = 'SUBMIT_COOP_DATA_SUCCESS';
export const SUBMIT_COOP_DATA_FAILURE = 'SUBMIT_COOP_DATA_FAILURE';
export const CLEAR_SELECTED_CHECKBOXES = 'CLEAR_SELECTED_CHECKBOXES';
export const LOADED_COOPS_ESCOLAR_ACTION = 'LOADED_COOPS_ESCOLAR_ACTION';
export const LOADED_TIPO_DOCUMENTO_ACTION = 'LOADED_TIPO_DOCUMENTO_ACTION';
export const SAVING_COOP_ESCOLAR = 'SAVING_COOP_ESCOLAR';
export const HANDLE_CHANGE_PROGRAMA_STATUS_ACTION =
  'HANDLE_CHANGE_PROGRAMA_STATUS_ACTION';
export const LOADED_ASSESSOR_DATA = 'LOADED_ASSESSOR_DATA';
export const SET_ENVIAR_FORMULARIO_PERIODO = 'SET_ENVIAR_FORMULARIO_PERIODO';

export const setEnviarFormularioPeriodo = (enviar: boolean) => ({
  type: SET_ENVIAR_FORMULARIO_PERIODO,
  payload: enviar,
});

export const loadedAssessorData = (data: AssessorData): LoadedAssessorDataAction => ({
  type: LOADED_ASSESSOR_DATA,
  payload: data,
});

export const setCurrentTab = (tab: EscolaEditTabs) => ({
  type: SET_CURRENT_TAB,
  payload: tab,
});

export const handleChangeProgramaDisabled = (
  tipoPrograma: TipoPrograma,
  status: boolean
) => ({
  type: HANDLE_CHANGE_PROGRAMA_STATUS_ACTION,
  payload: { tipoPrograma, status },
});

export const handleNext = () => ({
  type: HANDLE_NEXT,
});

export const handleBack = () => ({
  type: HANDLE_BACK,
});

export const openModal = (content: React.ReactNode) => ({
  type: OPEN_MODAL,
  payload: content,
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});

export const resetEscolasReducer = () => ({
  type: RESETED_ESCOLAS,
  payload: null,
});

export const clearPeriodoEditing = () => ({
  type: CLEARED_PERIODO_ACTION,
  payload: null,
});

export const clearPeriodoEditingCoop = () => ({
  type: CLEARED_PERIODO_COOP_ACTION,
  payload: null,
});

export const clearPeriodoEditingFinancas = () => ({
  type: CLEARED_PERIODO_FINANCAS_ACTION,
  payload: null,
});

export const clearEscolaEditing = () => ({
  type: CLEARED_ESCOLA_ACTION,
  payload: null,
});

export const clearIdebEditing = () => ({
  type: CLEARED_IDEB_ACTION,
  payload: null,
});

export const updateProgramaValue = (
  p: TipoPrograma | null,
  value: Partial<ProgramaCheckedAno>
) => {
  return {
    type: UPDATE_PROGRAMA_VALUE,
    payload: {
      tipo: p,
      value,
    },
  };
};

export const setCurrentTabPrograma = (tab: string) => ({
  type: SET_CURRENT_TAB_PROGRAMA,
  payload: tab,
});

export const resetProgramaValue = () => {
  return {
    type: RESET_PROGRAMA_VALUE,
    payload: {
      tipo: null,
      value: {},
    },
  };
};

const getEndpointDefault = (version: number) => {
  return getApis().apis.bff + 'v' + version + '/';
};

const getEndpoint = (version: number) => {
  return getApis().apis.bff + 'v' + version + '/escola';
};

const getEndpointPrograma = (version: number) => {
  return getApis().apis.bff + 'v' + version + '/programa';
};

const getEndpointPanorama = (version: number) => {
  return getApis().apis.bff + 'v' + version + '/panorama';
};

export const getEndpointPanoramaCoop = (version: number) => {
  return (
    getApis().apis.bff +
    'v' +
    version +
    '/panorama/cooperativa-escolar'
  );
};

export const getEndpointPanoramaFinancas = (version: number) => {
  return (
    getApis().apis.bff + 'v' + version + '/panorama/jornada'
  );
};

const getS3Endpoint = () => {
  return getApis().apis.bff + 'v1/documento/pdfs';
};

const getCoopEndpoint = () => {
  return `${getApis().apis.bff}v1/cooperativa-escolar`;
};

export const loadEscolasPorCidade = (
  cidade: string,
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESCOLAS_POR_CIDADE_ACTION,
      payload: true,
    });

    const isPublico = window.location.pathname.endsWith('/cadastro');
    const endpoint = isPublico
      ? getEndpoint(1) + '/publico/buscar/' + cidade
      : getEndpoint(1) + '/buscar/' + cidade;

    toRequest('get', [endpoint], 'escolasPorCidade').then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_POR_CIDADE_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESCOLAS_POR_CIDADE_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESCOLAS_POR_CIDADE_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEscolasPorCooperativaEstadoCidade = (
  codCoop: string,
  estadoId: number,
  cidade: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  const params = new URLSearchParams();
  if (typeof codCoop === 'string' && codCoop.length > 0) {
    params.append('codCoop', codCoop);
  }
  if (typeof estadoId === 'number' && estadoId > -1) {
    params.append('idEstado', estadoId.toString());
  }
  if (typeof cidade === 'string' && cidade.length > 0) {
    params.append('cidade', cidade);
  }
  const strParams = params.toString();
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [
        getEndpoint(1) +
        '/buscar' +
        (strParams.length > 0 ? '?' + strParams : ''),
      ],
      'escolasPorCidade'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEscolasPorCidadesECodCoop = (
  cidades: string[],
  codCoop: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION,
      payload: true,
    });
    toRequest(
      'post',
      [getEndpoint(1) + '/buscar/cidades-coops/' + codCoop, cidades],
      'escolasPorCidadesCoop'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEscolasPorCidadesECodCoopFluxoContratos = (
  cidades: string[],
  codCoop: string,
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION,
      payload: true,
    });

    const endpoint = getEndpoint(1) + '/buscar/cidades-coops/' + codCoop;

    toRequest('post', [endpoint, cidades], 'escolasPorCidadesCoop').then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_POR_CIDADE_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESCOLAS_POR_CIDADE_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESCOLAS_POR_CIDADES_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEscolas = (
  escolasNecessarias: string[],
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESCOLAS_ACTION,
      payload: true,
    });

    toRequest(
      'post',
      [getEndpoint(1), escolasNecessarias || []],
      'escolas'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESCOLAS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESCOLAS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEscolasByCoops = (
  codCoops: string[],
  status?: string[],
  escolasNecessarias?: string[],
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESCOLAS_BY_COOPS_ACTION,
      payload: true,
    });
    toRequest(
      'post',
      [
        `${getEndpoint(1)}/escolas-por-cooperativas`,
        {
          cooperativas: codCoops || [],
          status: status || [ESCOLA_STATUS_ATIVADA, ESCOLA_STATUS_DESATIVADA],
          escolasNecessarias: escolasNecessarias || [],
        },
      ],
      'escolas'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_BY_COOPS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESCOLAS_BY_COOPS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESCOLAS_BY_COOPS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEtapasEnsino = (
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ETAPAS_ENSINO_ACTION,
      payload: true,
    });
    toRequest('get', [`${getEndpoint(1)}/etapa-ensino`], 'etapasEnsino').then(
      (resp) => {
        dispatch({
          type: LOADED_ETAPAS_ENSINO_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ETAPAS_ENSINO_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ETAPAS_ENSINO_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadPrincipiosValores = (
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_PRINCIPIO_VALOR_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/principio-valor`],
      'principiosValores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PRINCIPIO_VALOR_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_PRINCIPIO_VALOR_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_PRINCIPIO_VALOR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearEscolasPageList = () => ({
  type: CLEARED_ESCOLAS_PAGE_ACTION,
  payload: null,
});

export const clearIdebList = () => ({
  type: CLEARED_ALL_IDEB_ACTION,
  payload: null,
});

export const loadEscolasPaginados = (
  queryString: string,
  callbackSuccess: (data: string) => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    const url = `${getEndpoint(1)}/page?${queryString}`;

    toRequest('get', [url], 'escolasPaginado').then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLAS_PAGE_ACTION,
          payload: {
            ...resp.data,
            filtro: new URLSearchParams(queryString).get('filtro'),
            page: parseInt(
              new URLSearchParams(queryString).get('page') || '0',
              10
            ),
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const changePeriodoEditingValue = (name: string, value: string) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_PERIODO_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_PERIODO_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_PERIODO_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const changeEscolaEditingValue = (name: string, value: string) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_ESCOLA_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_ESCOLA_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_ESCOLA_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const changeIdebEditingValue = (name: string, value: string) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_IDEB_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_IDEB_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_IDEB_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const changeEscolaStatus = (
  id: string,
  status: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'put',
      [`${getEndpoint(1)}/${id}/status/${status}`],
      'save'
    ).then(
      () => {
        dispatch({
          type: CHANGE_ESCOLA_STATUS_ACTION,
          payload: {
            id,
            status,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

function setupEscola(escola: { numero: string; cooperativa?: boolean }) {
  const escolaObj = {
    ...escola,
  };
  delete escolaObj.cooperativa;
  if (!escola.numero || escola.numero.trim().length === 0) {
    escolaObj.numero = NUMERO_NAO_INFORMADO;
  }
  return escolaObj;
}

export const deleteEscola = (
  idEscola: string,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return () => {
    toRequest("delete", [getEndpoint(1) + `/${idEscola}`]).then(
      (resp) => {
        callbackSuccess?.(resp);
      },
      (error) => {
        callbackError?.(error);
      }
    );
  };
};

export const createEscola = (
  escola: CadastroEscolaRequest,
  callbackSuccess: (resp: any) => void,
  callbackError: (message: string) => void
) => {
  const escolaObj = setupEscola(escola);
  return (dispatch: Dispatch) => {
    toRequest<CadastroEscola>('post', [
      `${getEndpoint(1)}/cadastro`,
      escolaObj,
    ]).then(
      (resp) => {
        dispatch({
          type: CREATED_ESCOLA_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveEscola = (
  escola: any,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void,
  callbackFinally?: () => void
) => {
  const escolaObj = setupEscola(escola);
  return (dispatch: Dispatch) => {
    toRequest('post', [`${getEndpoint(1)}/${escola.id}`, escolaObj], 'save')
      .then((resp) => {
        dispatch({
          type: SAVED_ESCOLA_ACTION,
          payload: resp.data,
        });
        callbackSuccess?.(resp);
      })
      .catch((error) => {
        callbackError?.(error);
      })
      .finally(() => {
        callbackFinally?.();
      });
  };
};

export const checkSemelhantes = (
  idEstado: number,
  cidade: string,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return () => {
    toRequest(
      'get',
      [`${getEndpoint(1)}/semelhante`, { params: { idEstado, cidade } }],
      'save'
    )
      .then((resp) => {
        callbackSuccess?.(resp);
      })
      .catch((error) => {
        callbackError?.(error);
      });
  };
};

export const createIdeb = (
  ideb: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('post', [`${getEndpoint(1)}/ideb/cadastro`, ideb], 'save').then(
      (resp) => {
        dispatch({
          type: CREATED_IDEB_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveIdeb = (
  ideb: { id: number },
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'put',
      [`${getEndpoint(1)}/ideb/${ideb.id}`, ideb],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: SAVED_IDEB_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadIdebById = (
  id: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('get', [`${getEndpoint(1)}/ideb/${id}/detalhe`], 'ideb').then(
      (resp) => {
        dispatch({
          type: LOADED_IDEB_ACTION,
          payload: {
            ...resp.data,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllIdebById = (
  id: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('get', [`${getEndpoint(1)}/ideb/escola/${id}`], 'ideb').then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_IDEBS_ACTION,
          payload: {
            id,
            ideb: [...resp.data],
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const removeIdebById = (
  id: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('delete', [`${getEndpoint(1)}/ideb/${id}`]).then(
      (resp) => {
        dispatch({
          type: REMOVED_IDEB_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEscolasByListCidades = (
  cidades: string[],
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
      payload: true,
    });
    toRequest(
      'post',
      [`${getEndpoint(1)}/buscar`, cidades],
      'escolas-by-list-cidades'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadModalidades = (
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_MODALIDADES_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [getEndpoint(1) + '/modalidade-escolar'],
      'modalidades'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_MODALIDADES_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_MODALIDADES_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_MODALIDADES_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const getProgramaInfo = (
  idEscola: string,
  tipoPrograma?: TipoPrograma,
  callbackSuccess?: (resp: ProgramasResponse[] | undefined) => void,
  callbackError?: (error: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({ type: LOADING_PROGRAMAS_ACTION, payload: true });
    toRequest<ProgramasResponse[]>(
      "get",
      [getEndpointPrograma(1) + `/escola/${idEscola}`, { params: {} }],
      'programas'
    )
      .then((resp) => {
        const data = resp.data;
        if (data.length > 0) {
          const programasMapeados = data.reduce((acc, item) => {
            acc[item.tipoPrograma] = {
              checked: item.ativo,
              anoImplementacao: item.anoImplementacao,
              ativo: item.ativo,
              disabled: false,
              tipoPrograma: item.tipoPrograma,
            };
            return acc;
          }, {} as Record<TipoPrograma, any>);
          dispatch({
            type: LOADED_PROGRAMA_INFO_ACTION,
            payload: programasMapeados,
          });
          callbackSuccess?.(data);
        } else {
          callbackSuccess?.([]);
        }
      })
      .catch((error) => {
        callbackError?.(error);
      })
      .finally(() => {
        dispatch({ type: LOADING_PROGRAMAS_ACTION, payload: false });
      });
  };
};


export const putPrograma = (
  idEscola: number,
  tipoPrograma: number,
  isAtivo: boolean,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return () => {
    const url = `${getEndpointPrograma(1)}/escola/${idEscola}/${tipoPrograma}/status/${isAtivo}`;

    toRequest("put", [url, {}], 'save').then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error: AxiosError) => {
        const message =
          error?.response?.statusText ||
          error?.response?.data?.message ||
          'Erro desconhecido';

        if (typeof callbackError === 'function') {
          callbackError(message);
        }
      }
    );
  };
};

export const postPrograma = (
  idEscola: number,
  tipoPrograma: number,
  anoImplementacao: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return () => {
    const url = `${getEndpointPrograma(1)}/escola/${idEscola}?tipoPrograma=${tipoPrograma}&anoImplementacao=${encodeURIComponent(anoImplementacao)}`;

    toRequest("post", [url, {}], 'save').then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error: AxiosError) => {
        const message =
          error?.response?.statusText ||
          error?.response?.data?.message ||
          'Erro desconhecido';

        if (typeof callbackError === 'function') {
          callbackError(message);
        }
      }
    );
  };
};

export const getCoopsEscolar = (
  idEscola: string,
  callbackSuccess?: (resp: any) => void,
  callbackError?: (error: any) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest<LoadedCoopEscola[]>('get', [
      getCoopEndpoint(),
      { params: { idEscola } },
    ]).then(
      (resp) => {
        dispatch({
          type: LOADED_COOPS_ESCOLAR_ACTION,
          payload: resp.data,
        });
        callbackSuccess?.(resp.data);
      },
      (error) => {
        callbackError?.(error);
      }
    );
  };
};

export const saveCoopEscolar = (
  idEscola: string,
  formData: FormData,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: SAVING_COOP_ESCOLAR,
      payload: true,
    });
    toRequest('post', [getCoopEndpoint(), formData, { params: { idEscola } }])
      .then((resp) => {
        callbackSuccess?.(resp);
      })
      .catch((error) => {
        callbackError?.(error);
      })
      .finally(() => {
        dispatch({
          type: SAVING_COOP_ESCOLAR,
          payload: false,
        });
      });
  };
};

export const putCoopEscolar = (
  idCoopEscolar: string,
  formData: FormData,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: SAVING_COOP_ESCOLAR,
      payload: true,
    });
    toRequest('put', [getCoopEndpoint() + `/${idCoopEscolar}`, formData])
      .then((resp) => {
        callbackSuccess?.(resp);
      })
      .catch((error) => {
        callbackError?.(error);
      })
      .finally(() => {
        dispatch({
          type: SAVING_COOP_ESCOLAR,
          payload: false,
        });
      });
  };
};

export const deleteCoopEscolar = (
  idEscola: string,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return () => {
    toRequest('delete', [getCoopEndpoint() + `/${idEscola}`]).then(
      (resp) => {
        callbackSuccess?.(resp);
      },
      (error) => {
        callbackError?.(error);
      }
    );
  };
};

export const getTipoDocumentacaoCoop = (
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest<LoadedTipoDocumento[]>('get', [
      getCoopEndpoint() + '/tipo-documentacao/lista',
    ]).then(
      (resp) => {
        dispatch({
          type: LOADED_TIPO_DOCUMENTO_ACTION,
          payload: resp.data,
        });
        callbackSuccess?.(resp);
      },
      (error) => {
        callbackError?.(error);
      }
    );
  };
};

export const downloadDocumentoCooperativa = (
  path: string,
  callbackSuccess?: (resp: AxiosResponse) => void,
  callbackError?: (resp: AxiosResponse) => void
) => {
  return () => {
    toRequest(
      'get',
      [`${getS3Endpoint()}/${path}`, { responseType: 'blob' }],
      'download-documento-cooperativa'
    )
      .then((resp) => {
        callbackSuccess?.(resp);
      })
      .catch((error) => {
        callbackError?.(error);
      });
  };
};

//PANORAMA PUFV
export const loadPeriodoByIdAndPeriodo = (
  id: string,
  periodo: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'get',
      [`${getEndpointPanorama(1)}/pufv/${id}/periodo/${periodo}`],
      'periodo'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PERIODO_ACTION,
          payload: { ...resp.data },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const removePeriodoByIdAndPeriodo = (
  id: string,
  periodo: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'delete',
      [`${getEndpointPanorama(1)}/pufv/${id}/periodo/${periodo}`],
      'periodo'
    ).then(
      () => {
        dispatch({
          type: REMOVED_PERIODO_ACTION,
          payload: {
            idEscola: id,
            periodo,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllPeriodos = (
  callbackSuccess?: () => void,
  callbackError?: (error: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_PERIODOS_ACTION,
      payload: true,
    });
    toRequest('get', [`${getEndpointDefault(1)}periodo`], 'periodo').then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_PERIODOS_ACTION,
          payload: [...resp.data],
        });
        dispatch({
          type: LOADING_ALL_PERIODOS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_PERIODOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadPeriodosById = (
  id: number,
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_PERIODOS_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpointPanorama(1)}/pufv/periodo/${id}`],
      'periodos'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PERIODOS_ACTION,
          payload: [...resp.data],
        });
        dispatch({
          type: LOADING_PERIODOS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_PERIODOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const savePeriodo = (
  periodo: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'put',
      [`${getEndpointPanorama(1)}/pufv/cadastro`, periodo],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: SAVED_PERIODO_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadDadosEscolaById = (
  id: string,
  page: number,
  callbackSuccess?: () => void,
  callbackError?: (error: string) => void
) => {
  return async (dispatch: Dispatch) => {
    try {
      const url = `${getEndpointPanorama(1)}/pufv/${id}?page=${page}&size=10`;
      const response = await toRequest("get", [url], 'panorama');
      dispatch({
        type: LOADED_DADOS_DA_ESCOLA_ACTION,
        payload: {
          id,
          dadosDaEscola: response.data.elements,
          pagePeriodoEscola: {
            page: response.data.page,
            totalElements: response.data.totalElements,
            totalPages: response.data.totalPages,
            elements: response.data.elements,
          },
        },
      });
      if (typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error: any) {
      if (typeof callbackError === 'function') {
        callbackError(error?.message || 'Erro ao carregar dados da escola.');
      }
    }
  };
};

export const loadEscolaById = (
  id: string,
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('get', [`${getEndpoint(1)}/${id}/detalhe`], 'escola').then(
      (resp) => {
        dispatch({
          type: LOADED_ESCOLA_ACTION,
          payload: {
            ...resp.data,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

//PANORAMA COOPERATIVAS

type PeriodoCoop = {
  idPeriodo: number;
  ensFundIIProf: number;
  ensFundIIAlun: number;
  ensMedioProf: number;
  ensMedioAlun: number;
  especializadaProf: number;
  especializadaAlun: number;
  colaboradores: number;
};

export const loadPeriodoByIdCooperativa = (
  id: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'get',
      [`${getEndpointPanoramaCoop(1)}/${id}`],
      'periodo'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PERIODO_COOP_ACTION,
          payload: { ...resp.data },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAnoByIdCooperativa = (
  id: number,
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_PERIODOS_COOP_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpointPanoramaCoop(1)}/ano/${id}`],
      'periodos'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PERIODOS_COOP_ACTION,
          payload: [...resp.data],
        });
        dispatch({
          type: LOADING_PERIODOS_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_PERIODOS_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const removePeriodoByIdCoopetiva = (
  periodo: string,
  idEscola: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('delete', [`${getEndpointPanoramaCoop(1)}/${periodo}`])
      .then(
        () => {
          dispatch({
            type: REMOVED_PERIODO_ACTION,
            payload: {
              idEscola: idEscola,
              periodo,
            },
          });
          if (typeof callbackSuccess === 'function') {
            callbackSuccess();
          }
        },
        (error) => {
          if (typeof callbackError === 'function') {
            callbackError(error);
          }
        }
      );
  };
};

export const loadDadosEscolaByIdCoop = (
  id: number,
  page: number,
  callbackSuccess?: () => void,
  callbackError?: (error: string) => void
) => {
  return async (dispatch: Dispatch) => {
    try {
      const url = `${getEndpointPanoramaCoop(1)}/listar/${id}?page=${page}&size=10`;
      const response = await toRequest("get", [url], 'panorama');
      dispatch({
        type: LOADED_DADOS_DA_ESCOLA_COOP_ACTION,
        payload: {
          id,
          dadosDaEscola: response.data.elements,
          pagePeriodoEscola: {
            page: response.data.page,
            totalElements: response.data.totalElements,
            totalPages: response.data.totalPages,
            elements: response.data.elements,
          },
        },
      });
      if (typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error: any) {
      if (typeof callbackError === 'function') {
        callbackError(error?.message || 'Erro ao carregar dados da escola.');
      }
    }
  };
};

export const postSavePeriodoCoop = (
  periodo: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'post',
      [`${getEndpointPanoramaCoop(1)}`, periodo],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: SAVED_PERIODO_COOP_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const putSavePeriodoCoop = (
  idPeriodo: string,
  data: PeriodoCoop
) => {
  return (onSuccess: () => void, onError: (error: any) => void) => {
    return (dispatch: Dispatch) => {
      toRequest(
        'put',
        [`${getEndpointPanoramaCoop(1)}/${idPeriodo}`, data],
        'save'
      ).then(
        (resp) => {
          dispatch({
            type: SAVED_PERIODO_COOP_ACTION,
            payload: resp.data,
          });
          if (typeof onSuccess === 'function') onSuccess();
        },
        (error) => {
          if (typeof onError === 'function') onError(error);
        }
      );
    };
  };
};

export const changePeriodoEditingValuePanoramaCoop = (
  name: string,
  value: string
) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION,
    payload: { name, value },
  };
};

//PANORAMA FINANÇAS
export const loadPeriodoByIdFinancas = (
  id: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'get',
      [`${getEndpointPanoramaFinancas(1)}/${id}`],
      'periodo'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PERIODO_FINANCAS_ACTION,
          payload: { ...resp.data },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAnoByIdFinancas = (
  id: number,
  callbackSuccess?: () => void,
  callbackError?: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_PERIODOS_FINANCAS_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpointPanoramaFinancas(1)}/ano/${id}`],
      'periodos'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PERIODOS_FINANCAS_ACTION,
          payload: [...resp.data],
        });
        dispatch({
          type: LOADING_PERIODOS_FINANCAS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_PERIODOS_FINANCAS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const putSavePeriodoFinancas = (
  idPeriodo: string,
  data: PeriodoCoop
) => {
  return (onSuccess: () => void, onError: (error: any) => void) => {
    return (dispatch: Dispatch) => {
      toRequest(
        'put',
        [`${getEndpointPanoramaFinancas(1)}/${idPeriodo}`, data],
        'save'
      ).then(
        (resp) => {
          dispatch({
            type: SAVED_PERIODO_FINANCAS_ACTION,
            payload: resp.data,
          });
          if (typeof onSuccess === 'function') onSuccess();
        },
        (error) => {
          if (typeof onError === 'function') onError(error);
        }
      );
    };
  };
};

export const postSavePeriodoFinancas = (
  periodo: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest(
      'post',
      [`${getEndpointPanoramaFinancas(1)}`, periodo],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: SAVED_PERIODO_FINANCAS_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const removePeriodoByIdFinancas = (
  periodo: string,
  idEscola: string,
  callbackSuccess: () => void,
  callbackError: (message: string) => void
) => {
  return (dispatch: Dispatch) => {
    toRequest('delete', [`${getEndpointPanoramaFinancas(1)}/${periodo}`])
      .then(
        () => {
          dispatch({
            type: REMOVED_PERIODO_ACTION,
            payload: {
              idEscola: idEscola,
              periodo,
            },
          });
          if (typeof callbackSuccess === 'function') {
            callbackSuccess();
          }
        },
        (error) => {
          if (typeof callbackError === 'function') {
            callbackError(error);
          }
        }
      );
  };
};

export const loadDadosEscolaByIdFinancas = (
  id: number,
  page: number,
  callbackSuccess?: () => void,
  callbackError?: (error: string) => void
) => {
  return async (dispatch: Dispatch) => {
    try {
      const url = `${getEndpointPanoramaFinancas(1)}/listar/${id}?page=${page}&size=10`;
      const response = await toRequest("get", [url], 'panorama');
      dispatch({
        type: LOADED_DADOS_DA_ESCOLA_FINANCAS_ACTION,
        payload: {
          id,
          dadosDaEscola: response.data.elements,
          pagePeriodoEscola: {
            page: response.data.page,
            totalElements: response.data.totalElements,
            totalPages: response.data.totalPages,
            elements: response.data.elements,
          },
        },
      });
      if (typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error: any) {
      if (typeof callbackError === 'function') {
        callbackError(error);
      }
    }
  };
};

export const changePeriodoEditingValuePanoramaFinancas = (
  name: string,
  value: string
) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION,
    payload: { name, value },
  };
};
